export const ModalActiveThemeAppExtension = {
  modal_heading: 'Veda Builder is not enabled!',
  modal_content_title: 'The page data has been saved to Veda. But you need to enable the app to make it live on your shop',
  modal_content_description: 'Click "Enable app" button to enbale Veda Builder app',
  modal_button: 'Enable app',
} as const;
